import MethodologySubTitle from './MethodologySubTitle'

export default MethodologySubTitle
